var map = {
	"./Gerl.jpg": 6857,
	"./Gerl2.jpg": 7085,
	"./Hech.jpg": 5545,
	"./Str.jpg": 2407,
	"./Sur.jpg": 7945,
	"./WW.jpg": 1162,
	"./WW2.jpg": 7838,
	"./Zent.jpg": 920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5953;